module.exports = __webpack_public_path__ + "static/media/Synthesis.d412be75.png";